/** Windows Phone viewport fix */
(function () {
    "use strict";
    if ("-ms-user-select" in document.documentElement.style && navigator.userAgent.match(/IEMobile\/10\.0/)) {
        var msViewportStyle = document.createElement("style");
        msViewportStyle.appendChild(document.createTextNode("@-ms-viewport{width:auto!important}"));
        document.getElementsByTagName("head")[0].appendChild(msViewportStyle);
    }
})();

/**
 * @see https://remysharp.com/2010/07/21/throttling-function-calls
 * @param fn
 * @param delay
 * @returns {Function}
 */
function debounce(fn, delay) {
    var timer = null;
    return function () {
        var context = this, args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
            fn.apply(context, args);
        }, delay);
    };
}

var Agan = {};

/**
 * @see https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent
 * @returns {boolean}
 */
window.isMobileDevice = function () {
    "use strict";
    return /Mobi/.test(navigator.userAgent);
};

/** Short-Handle for document.ready */
$(function () {

    var $window = $(window), $oBody = $('body'), $oHeader = $('#header'), $oBasketList = $('#basket_list'),
        $oRecommendations = $('#econdaRecommendations'), $oChangeEmail = $('input.oxValidate_enterPass'),
        $oSearchInput = $('#searchParam'), $sliderContainer = $('.agan-slidebar-container');

    /** Search toggle */
    $('.search-toggle').click(function (e) {
        e.preventDefault();

        $('html, body').animate({
            scrollTop: ($oSearchInput.position().top - 10 || 0)
        }, 300, function () {
            $oSearchInput.focus();
        });
    });

    /** Load Megamenu Images only if Desktop */
    if (!(isMobileDevice())) { // wenn nicht mobile
        $('div[class^="mega-nav-item-"]').find('img').each(function () { // finde alle DIV's, deren Klassenname mit 'maga-nav-item-' beginnt, dann schaue nach, ob darin ein 'img' ist. Falls ja, schicke jedes Image durch folgene Funktion:
            if ($(this).attr('src')) {    // Hat dieses Element ( Image ) ein 'src' Attribut?
                this.src = $(this).attr('data-src'); // dann setze den Attributwert auf den Wert von 'data-src'
            } else if ($(this).attr('srcset')) {     // oder hat das Element ein 'srcset' Attribut?
                this.srcset = $(this).attr('data-source'); // dann setze den Attributwert auf den Wert von 'data-source'
            }
        });
    }

    /** Fix to focus input fields in bootstrap dropdown menus. */
    $('#header .dropdown-menu input, #header .dropdown-menu label, #header .dropdown-menu button, #header .dropdown-menu').click(function (e) {
        e.stopPropagation();
    });

    $oHeader.find('.menu-dropdowns button[data-href]').click(function (e) {
        var $this = $(this);

        if ($(window).width() <= 767) {
            e.stopPropagation();
            document.location.href = $this.attr('data-href');
        }
    });

    if ($oRecommendations.length) {
        $.get(window.sBaseUrl + 'cl=tpl&tpl=ajax_econda_recommendations.tpl&actcl=' + sActCl + '', function (oData, sStatus, oXhr) {
            $oRecommendations.html(oData);
        });
    }

    /** List Filter */
    var $oFilterList = $('#filterList');

    if ($oFilterList.length) {
        $oFilterList.find('.dropdown-menu li').click(function () {
            var $this = $(this);
            $this.parent().prev().val($this.children().first().data('selection-id'));
            $this.closest('form').submit();
        });
    }

    var $oSidebar = $('#sidebar'), $oCategoryBox = $oSidebar.find('.box.categorytree');
    if ($oCategoryBox.length) {
        $oCategoryBox.find('.toggleTree').on('click touch', function () {
            var $this = $(this), $oCategoryTreeBox = $this.parents('.categorytree').find('.categoryBox');

            if ($this.hasClass('fa-caret-down')) {
                $this.removeClass('fa-caret-down');
                $this.attr('class', 'fa-caret-up ' + $this.attr('class'));
                $oCategoryTreeBox.attr('style', 'display:block!important');
            } else {
                $this.removeClass('fs-caret-up');
                $this.attr('class', 'fs-caret-down ' + $this.attr('class'));
                $oCategoryTreeBox.removeAttr('style');
            }
        });
    }

    /** Variant selection in lists */
    var $oSelectionLists = $('.selectorsBox');

    if ($oSelectionLists.length) {
        $oSelectionLists.find('.dropdown-menu li').click(function (e) {
            e.preventDefault();
            var $this = $(this);
            $this.parent().prev().val($this.children().first().data('selection-id'));
            $this.closest('form').submit();
        });
    }

    /** Details page */
    Agan.initEvents = function () {
        /** Lazy Loading for images */

        AganLazy({
            onImageLoad: (imgEl) => {
                /* Load */
                imgEl.classList.remove('isLoading');
            }, onImageError: (imgEl) => {
                /* Error
                   console.log('error ->', imgEl); */
            }, allImagesFinished: () => {
                let removeAllSkeletons = document.querySelectorAll('.skeleton');
                [...removeAllSkeletons].forEach((skeleton) => {
                    skeleton.classList.remove('skeleton', 'isLoading');
                });
            }, defaultImage: 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=='
        }).lazy('img');

        $(".selectpicker").selectpicker();

        /** Global Tooltip-Class */
        $('.hasTooltip').tooltip();

        /** Global PopOver-Class */
        $('.hasPopover').popover();
    };
    Agan.initEvents();

    /** Basket */
    if ($oBasketList.length) {
        $('#basket_form').on('submit', function (e) {
            var $this = $(this), $oHiddenXs = $this.find('.hidden-xs'), $oVisibleXs = $this.find('.visible-xs');

            if ($oHiddenXs.is(':hidden')) {
                $oHiddenXs.remove();
            }

            if ($oVisibleXs.is(':hidden')) {
                $oVisibleXs.remove();
            }

            //e.target.submit();
        });

        $oBasketList.find('.toggle-actions').click(function (e) {
            e.preventDefault();
            var $this = $(this), $oToggable = $this.parents('li').first().find('.row.toggable');

            $oToggable.slideToggle(150, function () {
                $this.find('i').attr('class', ($oToggable.is(':visible') ? 'fa fa-chevron-up' : 'fa fa-chevron-down'));
            });
        });
    }

    /** Account */
    if ($oChangeEmail.length) {
        var sOldMail = $oChangeEmail.val(), $oPasswordElem = $('.oxValidate_pwd');
        $oChangeEmail.keyup(function (e) {
            if ($oPasswordElem.length) {
                if (sOldMail != e.target.value) {
                    $oPasswordElem.slideDown('fast');
                } else {
                    if ($oPasswordElem.is(':visible')) {
                        $oPasswordElem.slideUp('fast');
                    }
                }
            }
        });
    }

    /** Private Sales Login */
    $('#private-sales-login input.agb-check').click(function () {
        if ((this).checked) {
            $('#private-sales-login button.submitButton').removeAttr('disabled');
        } else {
            $('#private-sales-login button.submitButton').attr("disabled", "disabled");
        }
    });

    /** Footer Mobile Accordion */
    var $footerAccordion = $("#footer-accordion");
    if ($footerAccordion.length) {
        $footerAccordion.accordion({
            active: false, collapsible: true, heightStyle: 'content'
        });
    }

    /** mobile Slidebar */
    $('#mobilemenu').aganMobilemenu({
        closeOnOrientationChange: true, orientationChangeBreakpoint: "(min-width: 1023px)"
    });

    /** set body class if its a mobile device */
    if (window.isMobileDevice()) {
        $('body').addClass('is-mobile-device');
    }

    /** set alt Attribute if not exists or add prefix */
    let lang = document.documentElement.lang || 'de';

    let prefixMap = {
        'de': 'Bild von ',
        'fr': 'Image de ',
        'es': 'Imagen de ',
        'it': 'Immagine di '
    };

    const prefix = prefixMap[lang] || prefixMap.de;

    $('img').each(function () {
        let currentAlt = $(this).attr('alt') || 'asgoodasnew';

        if (!currentAlt.startsWith(prefix)) {
            $(this).attr('alt', prefix + currentAlt);
        }
    });


    /** Prevent the default input field behaviour on registration site, otherwise the "delete account" button will appear. */
    $('#shippingAddressForm , #addressForm').keypress(function (event) {
        if (event.keyCode === 13 || event.keyCode === 10) event.preventDefault();
    });

    /** Set eKomi rel Attribute to no-follow */
    var set_nofollow = true; // ! in case of trouble with eKomi set this flag to false
    function setEkomi2noFollow() {
        if (set_nofollow) {
            var ekomi_footer = $('a#eKomiSeal_9EF2A8E20E0EF13_eKomiSeal_footer');
            //var ekomi_header = $('a#eKomiSeal_9EF2A8E20E0EF13_eKomiSeal_header');
            var ekomi_basket = $('a#eKomiSeal_9EF2A8E20E0EF13_eKomiSeal_basket');

            ekomi_footer.attr('rel', 'nofollow');
            //ekomi_header.attr('rel', 'nofollow');
            ekomi_basket.attr('rel', 'nofollow');
        }
    }

    setTimeout(setEkomi2noFollow, 60);

    /** Prevent default click-behaviour ( add class 'open') from bootstrap on dropdown 'more' */
    $('.moreLinks').click(function (event) {
        setTimeout(removeOpenClass, 120);
    });

    function removeOpenClass() {
        $('.moreLinks').removeClass('open');
    }

    /** Remove Filter Description on Product-List */
    var $sortElem = $('.mobilefilter-button--sort > strong');
    if ($sortElem.length) {
        $sortElem.remove();
    }

    /** Swiper */
    var swiperSlider = new Swiper('.swiperslider .swiper-container', {
        slidesPerView: 3,
        spaceBetween: 10,
        slidesPerGroup: 3,
        loop: true,
        direction: 'horizontal',
        loopFillGroupWithBlank: true,
        breakpoints: {
            400: {
                slidesPerView: 2, spaceBetween: 10, slidesPerGroup: 2,
            }, 500: {
                slidesPerView: 2, spaceBetween: 20, slidesPerGroup: 2,
            }, 650: {
                slidesPerView: 3, spaceBetween: 15, slidesPerGroup: 3,
            }, 768: {
                slidesPerView: 3, spaceBetween: 15, slidesPerGroup: 3,
            }, 1024: {
                slidesPerView: 3, spaceBetween: 10, slidesPerGroup: 3,
            },
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        }
    });

    /** Basket Voucher Success Bar */

    if ($('.cl-basket').length) {
        let couponData = $('.couponData');
        let alertDangerInfo = $('#basketVoucher').find('.alert-danger');

        if (couponData.length && alertDangerInfo.length === 0) {
            $(".voucher-successBar").css({"display": "block"});

            setTimeout(function () {
                $(".voucher-successBar").fadeOut(300);
            }, 3000);
        }
    }

    /**
     * script to reorganize navbar items
     */
    const megaMenuChildItems = document.querySelectorAll('#navigation li:not(.moreLinks)');
    const moreDropdown = document.querySelector('#navigation .moreLinks .dropdown-menu');
    const moreLinks = document.querySelector('.moreLinks');

    function reRenderMainNav(appendMode = false) {
        let navigationWidth = document.querySelector('#navigation').offsetWidth;
        let itemWidth = 0;

        // navigation changes no need to check below
        if (document.body.classList.contains('is-checkout') ||
            navigationWidth < 1023 || megaMenuChildItems.length == 0) {
            return;
        }

        // check menu items overlapping
        megaMenuChildItems.forEach((megaMenuChild) => {
            itemWidth += megaMenuChild.offsetWidth;

            if (itemWidth > navigationWidth - 150 && !megaMenuChild.classList.contains("isInMoreList")) {
                // hide item in menu and put it to more-dropdown
                if (appendMode) {
                    moreDropdown.append(megaMenuChild.cloneNode(true));
                } else {
                    moreDropdown.prepend(megaMenuChild.cloneNode(true));
                }
                megaMenuChild.classList.add("hideItem", "isInMoreList");
            } else if (itemWidth < navigationWidth - 150 && megaMenuChild.classList.contains("isInMoreList")) {
                // restore item in list when enough space
                moreDropdown.removeChild(moreDropdown.firstElementChild);
                megaMenuChild.classList.remove("hideItem", "isInMoreList");
            }
        });
        if (moreDropdown.childNodes.length == 0) {
            moreLinks.style.display = "none";
        }
    }

    // if MegaMenu Module is activated - in prod with backend, NOT in module.prod
    if (document.querySelector(".mega-nav")) {
        // Call function once and on resize
        reRenderMainNav(true);
        window.addEventListener('resize', () => {
            reRenderMainNav(false);
        });
    }

    /** Footer SEO - reduce DOM Size */
    let footerHTML = "";
    let $footerElem = $("#footer");
    var eTop = $footerElem.offset().top - $(window).height() - 100;

    // Remove Footer if under the fold.
    // If scrolled down to footer (or scroled more than 300 px) paste it in again
    function checkFooterShown() {
        if (eTop - $(".agan-slidebar-container").scrollTop() > 0 && $(".agan-slidebar-container").scrollTop() < 300) {
            if ($footerElem.children(".agan-container").length > 0 && !$footerElem.hasClass("pasted-in")) {
                footerHTML = $footerElem.children(".agan-container").clone(true);
                $footerElem.children(".agan-container").remove();
            }
        } else {
            if ($footerElem.children(".agan-container").length == 0) {
                $footerElem.prepend(footerHTML);
                $footerElem.addClass("pasted-in");
                if (typeof initEkomiSeal === 'function') {
                    initEkomiSeal();
                }
            }
        }
    }

    checkFooterShown();
    $(".agan-slidebar-container").on('scroll', checkFooterShown);

    /** Toggle attribute 'type' password/text on click on icon in login input box */
    const togglePasswordArray = document.querySelectorAll(".togglePassword");

    togglePasswordArray.forEach(togglePassword => {
        togglePassword.addEventListener("click", function () {
            const password = togglePassword.previousElementSibling;
            // toggle the type attribute
            const type = password.getAttribute("type") === "password" ? "text" : "password";
            password.setAttribute("type", type);
            // toggle the icon
            this.classList.toggle("agan_icon--eye-closed");
        });
    });

    /** Check and validate password requirements - START */
    const {classList} = document.body;
    const i18nEl = document.getElementById("passwordI18n");
    const t = i18nEl ? i18nEl.dataset : {};

    const password = document.querySelector('[data-role="password"]');
    const passwordRepeat = document.querySelector('[data-role="password-repeat"]');

    const message = document.getElementById("passwordMessage");

    /** BE Validation: Modul Fatchip - Better Login -> Einstellungen **/
    const SPECIAL_RE = /[*.!@$%^&(){}\[\]:;<>,.?\/~_+\-=|\\#§]/;

    const labels = {
        title: t.title || "Passwortanforderungen:",
        empty: t.msgEmpty || "",
        valid: t.msgValid || "✔ Passwort ist gültig",
        length: t.ruleLength || "mindestens 8 Zeichen",
        upper: t.ruleUpper || "Großbuchstabe",
        lower: t.ruleLower || "Kleinbuchstabe",
        number: t.ruleNumber || "Ziffer",
        special: t.ruleSpecial || "Sonderzeichen",
        match: t.ruleMatch || "Passwörter stimmen überein"
    };

    function validatePassword() {
        const pwd = password.value;
        const repeat = passwordRepeat.value;

        const rules = {
            length: pwd.length >= 8,
            upper: /[A-Z]/.test(pwd),
            lower: /[a-z]/.test(pwd),
            number: /[0-9]/.test(pwd),
            special: SPECIAL_RE.test(pwd),
            match: pwd === repeat && pwd !== ""
        };

        const allValid = Object.values(rules).every(Boolean);

        if (!pwd && !repeat) {
            message.textContent = "";
            return;
        }

        if (!allValid) {
            message.innerHTML = `
                    ${labels.title}
                    <ul>
                      <li class="${rules.length ? 'success' : 'error'}">
                        ${rules.length ? "✔" : "✖"} ${labels.length}
                      </li>
                      <li class="${rules.upper ? 'success' : 'error'}">
                        ${rules.upper ? "✔" : "✖"} ${labels.upper}
                      </li>
                      <li class="${rules.lower ? 'success' : 'error'}">
                        ${rules.lower ? "✔" : "✖"} ${labels.lower}
                      </li>
                      <li class="${rules.number ? 'success' : 'error'}">
                        ${rules.number ? "✔" : "✖"} ${labels.number}
                      </li>
                      <li class="${rules.special ? 'success' : 'error'}">
                        ${rules.special ? "✔" : "✖"} ${labels.special}
                      </li>
                      <li class="${rules.match ? 'success' : 'error'}">
                        ${rules.match ? "✔" : "✖"} ${labels.match}
                      </li>
                    </ul>
                    `;
            message.className = "password-message";
        } else {
            message.textContent = labels.valid;
            message.className = "password-message success";
        }
    }

    if (['cl-register', 'cl-account_password', 'cl-forgotpwd'].some(cl => classList.contains(cl))) {



        if (password) {
            password.addEventListener("input", validatePassword);
            passwordRepeat.addEventListener("input", validatePassword);
        }
    }
    /** Check and validate password requirements - END */

    if (window.isMobileDevice()) {
        $('.mobileSearchBtn').click(function () {
            $('.mobileSearchInput').find('#searchParam').focus();
        });
    }

    if (document.body.classList.contains('is-checkout')) {
        const voucher = document.querySelector('.couponData');
        const flyout = document.querySelector('#klarnaVouchersWidget');
        const flyoutContent = document.querySelectorAll('.drop-content').forEach(el => el.style.display = 'none');

        if (voucher) {
            flyout.classList.remove('active');
        }

        const targetClasses = ['klarna-voucher-label', 'klarna-login-label'];

        targetClasses.forEach(className => {
            const elements = document.querySelectorAll(`.${className}`);
            elements.forEach(el => {
                const cancelOverlay = document.createElement('span');
                cancelOverlay.className = 'klarna-cancel-overlay';
                cancelOverlay.textContent = 'X';

                if (el && el.parentNode) {
                    el.parentNode.insertBefore(cancelOverlay, el.nextSibling);
                }
            });
        });
    }

    /** Snackbar */
    function showSnackbar(message, duration = 3500) {
        const bar = document.getElementById("snackbar");

        bar.classList.remove("show");
        bar.textContent = message;

        setTimeout(() => {
            bar.classList.add("show");
        }, 10);

        setTimeout(() => {
            bar.classList.remove("show");
        }, duration + 10);
    }

    if ($('.cl-details').length) {

        // Snackbar for Noticelist - data from localStorage

        const msg = localStorage.getItem('snackbarMessage');

        if (msg) {
            showSnackbar(msg);
            localStorage.removeItem('snackbarMessage');
        }

        $('.linkToNoticeList').on('click', function (e) {
            const text = $(this).data('snackbar');
            localStorage.setItem('snackbarMessage', text);
        });
    }

    // Snackbar for copy Article Number - data from ClickItem

     $('#copyArtNr').on('click', function (e) {

         // copy Article Number to Clipboard
         const artNum = $(this).text();
         navigator.clipboard.writeText(artNum);

         // show Snackbar
         const snackbarText = $(this).data('snackbar');
         showSnackbar(snackbarText);
     });

    if ($('.cl-start').length ||
        $('.cl-basket').length ||
        $('.cl-alist').length ||
        $('.cl-search').length ||
        $('.cl-details').length) {
        // Snackbar for copy Voucher Code - data from ClickItem
        // Modul: agan_marketingtool -> Slim Banner

        $('#slimBannerCode').on('click', function (e) {

            // copy Voucher Code to Clipboard
            const voucherCode = $(this).text();
            navigator.clipboard.writeText(voucherCode);

            // show Snackbar
            const snackbarText = $(this).data('snackbar');
            showSnackbar(snackbarText);
        });
    }

    /** Melibo Chatbot: hide Bubble on mobile and set trigger for custom button and link */
    function isMobile() {
        return window.matchMedia("(max-width: 767px)").matches;
    }

    function whenMeliboReady(cb) {
        if (window.melibo) return cb(window.melibo);
        const i = setInterval(() => {
            if (window.melibo) {
                clearInterval(i);
                cb(window.melibo);
            }
        }, 50);
        setTimeout(() => clearInterval(i), 8000);
    }

    whenMeliboReady((melibo) => {
        if (isMobile()) melibo.hideToggleButton();
    });

    window.addEventListener("resize", () => {
        if (!window.melibo) return;
        if (isMobile()) window.melibo.hideToggleButton();
        else window.melibo.showToggleButton();
    });

    const triggers = document.querySelectorAll(".melibo-trigger");
    triggers.forEach((trigger) => {
        trigger.addEventListener("click", (e) => {
            e.preventDefault();
            whenMeliboReady((melibo) => {
                melibo.openWidget();
            });
        });
    });
});
